import apiClient from '../api/apiClient';

const UPLOAD_URL = '/api/v1/admin/company-intelligence/upload-files';

const UPLOAD_TIMEOUT_MS = 600000;

const multipartConfig = {
  timeout: UPLOAD_TIMEOUT_MS,
  headers: {
    'Content-Type': false,
  },
};

const unwrap = (response) => response.data?.data ?? response.data;

/**
 * Upload Tracxn JSON/JSONL dumps for listed Pre-IPO products.
 * @param {Record<string, File[]>} filesByField - keys: companies, financials, captables, competitors, fundingRounds
 */
export async function uploadTracxnFiles(filesByField) {
  const formData = new FormData();

  for (const [field, files] of Object.entries(filesByField)) {
    if (!files?.length) continue;
    for (const file of files) {
      formData.append(field, file);
    }
  }

  const response = await apiClient.request({
    method: 'POST',
    url: UPLOAD_URL,
    data: formData,
    ...multipartConfig,
  });

  return {
    message: response.data?.message,
    summary: unwrap(response),
  };
}

export default {
  uploadTracxnFiles,
};
